/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Button } from 'antd';
import dayjs from 'dayjs';
import { LoadingOutlined } from '@ant-design/icons';
import CartActions from '@Actions/cartActions';
import { QUANTITY, toISTDate } from '@Apis/constants';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import H3Image from '@Uilib/h3Image';
import imageDefault from '@Images/icons/imageDefault.png';
import './styles.scss';
/**
 * @param value
 */
class PreviewPo extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        {
          title: '',
          render: (text, record) => (
            record?.assets?.[0]?.url
              ? <H3Image src={record?.assets[0].url} className="prod-table__image" />
              : <H3Image src={imageDefault} className="prod-table__image prod-table__image__default" />
          ),
          width: '60px',
        },
        {
          title: 'Product Name',
          render: (record) => <div>{record?.productName}</div>,
          width: '50%',
        },
        {
          title: 'Quantity',
          render: (record) => <div>{`${QUANTITY(record?.quantity, record?.uomInfo?.precision)} ${record?.uomInfo?.uqc?.toProperCase() || ''}`}</div>,
          width: '10%',

        },
        {
          title: 'Unit Price',
          render: (record) => this.props.MONEY(record?.unitPrice),
          width: '12%',
        },
        {
          title: 'TAX',
          render: (record) => `${ record?.taxInfo ? record?.taxInfo?.tax_value : 0}%`,
          width: '10%',

        },
        {
          title: 'LINE TOTAL',
          render: (record) => this.props.MONEY(this.getLineTotal(record) || 0),
        },

      ],
      tenantSellerCartItems: {},
      actionType: '',
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getCart, user } = this.props;
    getCart(user?.tenant_info?.tenant_id);
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && props.cart && !state.isUserReady) {
      const { cart } = props;
      const tenantSellerCartItems = {};
      for (let i = 0; i < cart?.data?.cartData?.length; i++) {
        const cartItem = cart?.data?.cartData?.[i];
        if (tenantSellerCartItems.hasOwnProperty(cartItem?.tenantSellerId)) {
          tenantSellerCartItems[cartItem?.tenantSellerId].push(cartItem);
        } else {
          tenantSellerCartItems[cartItem?.tenantSellerId] = [cartItem];
        }
      }
      return {
        ...state,
        isUserReady: true,
        tenantSellerCartItems,
      };
    }
    return state;
  }

  /**
   * @param withApproval
   */
  handleCreatePo(withApproval) {
    const { tenantSellerCartItems } = this.state;
    const {
      user, createPurchaseOrder, addToCart, getCart, history, tenantsConfiguration,
    } = this.props;
    const cartItemGroup = Object.values(tenantSellerCartItems);
    const payload = [];
    for (let i = 0; i < cartItemGroup?.length; i++) {
      const purchaseOrder = {};
      purchaseOrder.tenant_seller_id = cartItemGroup?.[i]?.[0]?.sellerInfo?.tenant_seller_id;
      purchaseOrder.tenant_seller_info = cartItemGroup?.[i]?.[0]?.tenantSellerInfo;
      purchaseOrder.tenant_id = user?.tenant_info?.tenant_id;
      purchaseOrder.shipping_address_id = user?.tenant_info?.default_shipping_address;
      purchaseOrder.billing_address_id = user?.tenant_info?.default_billing_address;
      purchaseOrder.seller_address_id = cartItemGroup?.[i]?.[0]?.sellerInfo?.office_address_id;
      purchaseOrder.payment_terms = [cartItemGroup?.[i]?.[0]?.sellerInfo?.default_payment_terms];
      purchaseOrder.edd = toISTDate(dayjs().format('YYYY/MM/DD'));
      purchaseOrder.po_date = toISTDate(dayjs().format('YYYY/MM/DD'));
      purchaseOrder.t_and_c = tenantsConfiguration?.data?.[0]?.default_t_and_c || '';
      purchaseOrder.status = withApproval ? 'ISSUED' : 'DRAFT';
      purchaseOrder.purchase_order_lines = cartItemGroup?.[i]?.map((item) => ({
        tenant_product_id: item?.tenantProductId,
        product_sku_name: item?.productName,
        product_sku_id: item?.product_sku_info?.productSkuId,
        offer_price: item?.unitPrice,
        quantity: item?.quantity,
        tax_id: item?.taxId,
        tax_info: [item?.taxInfo],
        uom_id: item?.uomId,
        uom_info: [item?.uomInfo],
      }));
      payload.push(purchaseOrder);
    }
    createPurchaseOrder(payload, () => {
      addToCart({
        cartData: [],
      }, user?.tenant_info?.tenant_id, () => {
        getCart(user?.tenant_info?.tenant_id);
        history.push('/purchase/purchase-orders');
        this.setState({ actionType: '' });
      });
    }, false);
  }

  /**
   *
   * @return
   */
  getTotal() {
    const { cart } = this.props;
    let total = 0;
    cart?.data?.cartData?.map((item) => {
      total += (Number(item?.unitPrice || 0) * Number(item?.quantity || 0) * (1 + item?.taxInfo?.tax_value / 100));
    });
    const length = cart?.data?.cartData?.length;
    return {
      total,
      length,
    };
  }

  /**
   * @return
   * @param record
   */
  getLineTotal(record) {
    let total = 0;
    total = (record?.quantity * record?.unitPrice) * (1 + record?.taxInfo?.tax_value / 100);
    return total;
  }

  /**
   *
   * @return
   */
  render() {
    const {
      getCartLoading, addToCartLoading, createPurchaseOrderLoading, MONEY,
    } = this.props;
    const {
      columns, tenantSellerCartItems, actionType,
    } = this.state;
    return (
      <div className="po__preview-container">
        <div className="po__preview-container-heading">
          {Object.keys(tenantSellerCartItems)?.length}
          {' '}
          Purchase orders will be created as part of this order
        </div>
        {Object.values(tenantSellerCartItems)?.map((cartRow) => (
          <Table
            title={() => (
              <div className="po__preview-title">
                {cartRow?.[0]?.sellerInfo?.seller_name}
              </div>
            )}
            loading={getCartLoading || addToCartLoading}
            columns={columns}
            size="small"
            dataSource={cartRow}
            key={cartRow?.[0]?.sellerInfo?.seller_id}
            pagination={false}
          />
        )) }

        <div className="cart__preview__footer-container">
          <div className="cart__preview__footer-left">
            {MONEY(this.getTotal().total)}
            <span style={{ color: 'black', fontWeight: '400', marginLeft: '10px' }}>
              (
              {this.getTotal().length}
              {' '}
              Items in Cart)
            </span>
          </div>
          <div className="cart__preview__footer-right">
            <Button
              type="primary"
              ghost
              onClick={() => {
                this.setState({ actionType: 'SAVE_AS_DRAFT' });
                this.handleCreatePo(false);
              }}
              style={{ width: '150px' }}
            >
              {(createPurchaseOrderLoading && actionType === 'SAVE_AS_DRAFT') ? <LoadingOutlined /> : 'Save as Draft'}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                this.setState({ actionType: 'SAVE_AND_ISSUE' });
                this.handleCreatePo(true);
              }}
              style={{ width: '150px', marginLeft: '10px' }}
            >
              {(createPurchaseOrderLoading && actionType === 'SAVE_AND_ISSUE') ? <LoadingOutlined /> : 'Save & Issue'}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, CartReducers, PurchaseOrderReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  cart: CartReducers.cart,
  getCartLoading: CartReducers.getCartLoading,
  addToCartLoading: CartReducers.addToCartLoading,
  createPurchaseOrderLoading: PurchaseOrderReducers.createPurchaseOrderLoading,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,

});

const mapDispatchToProps = (dispatch) => ({
  getCart: (tenantId) => dispatch(CartActions.getCart(tenantId)),
  addToCart: (payload, tenantId, callback) => dispatch(CartActions.addToCart(payload, tenantId, callback)),
  createPurchaseOrder: (payload, callback, withApproval) => dispatch(PurchaseOrderActions.createPurchaseOrder(payload, callback, withApproval)),
});

PreviewPo.propTypes = {
  addToCart: PropTypes.func,
  getCart: PropTypes.func,
  user: PropTypes.any,
  getCartLoading: PropTypes.any,
  addToCartLoading: PropTypes.any,
  createPurchaseOrder: PropTypes.func,
  cart: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PreviewPo));
